import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import _ from 'lodash';

/*
 * Rules for using this component:
 * - the input element that you're trying to focus must NOT be the
 *   outermost element of your InputComponent
 *   (querySelector only finds descendents of the elt it's acting on)
 * - you need to pass the InputComponent's className prop down to
 *   the input element
 * - you can't have several instances of this component trying to focus
 *   at the same time
 */

function focusableWrapper (InputComponent) {
    return class extends React.PureComponent {

        static propTypes = {
            className: PropTypes.string,
            focused: PropTypes.bool
        };

        static defaultProps = {
            className: '',
            focused: false
        };

        componentDidUpdate(prevProps) {
            if (!prevProps.focused && this.props.focused) {
                const focusedElt = ReactDOM.findDOMNode(this.inputElement).querySelector('.input--focused');
                if (focusedElt) {
                    focusedElt.focus();
                    focusedElt.scrollIntoView();
                }
            }
        }

        render() {
            const { className, focused } = this.props;
            const classNames = classnames(className, { 'input--focused': focused });

            const newProps = _.omit(this.props, ['className', 'focused']);
            return (
                <InputComponent
                    ref={ el => { this.inputElement = el; } }
                    { ...newProps }
                    className={ classNames }/>
            );
        }
    };
}

export default focusableWrapper;
